import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { calculationService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useCalculateMutation = ({
	paidYear,
	paidMonth,
	onSuccessHandler,
}: {
	paidYear: string;
	paidMonth: string;
	onSuccessHandler?: Function;
}) => {
	const dispatch = useDispatch();

	return useMutation(
		({ acceptMerchantChanges }: { acceptMerchantChanges?: boolean }) => {
			dispatch(uiActions.showSpinnerOverlay());

			return calculationService.calculate({
				paidYear,
				paidMonth,
				acceptMerchantChanges,
			});
		},
		{
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
			onSuccess() {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Calculation process is in progress now",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useCalculateMutation;
